<template>
  <div>Logging out...</div>
</template>

<script>
import { performLogoutWithoutRedirect } from '@/auth/logout'
export default {
  mounted() {
      performLogoutWithoutRedirect(this.$store)
  }
}
</script>
